export default __webpack_public_path__ + "static/media/card-assessment-icon.c389a90c.svg";